import { Pipe, PipeTransform } from '@angular/core';
import { UtilsHelper } from '@helpers/utils-helper';

@Pipe({
  name: 'lengthLimit',
})
export class LengthLimitPipe implements PipeTransform {
  public transform(value: string, limit: number): string {
    return UtilsHelper.limitLength(value, limit);
  }
}
